export default __webpack_public_path__ + "static/media/application-img-03.4e198eaa.png";